var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uPicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-picker/u-picker" */ "uview-ui/components/u-picker/u-picker.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.currentStep === 1 ? _vm.areaList && _vm.areaList.length > 0 : null
  var m0 =
    !(_vm.currentStep === 1) &&
    _vm.qualificationType === "personal" &&
    !!_vm.form.idcardImg
      ? _vm.getFullPath(_vm.form.idcardImg)
      : null
  var m1 =
    !(_vm.currentStep === 1) &&
    _vm.qualificationType === "personal" &&
    !!_vm.form.idcardImgBack
      ? _vm.getFullPath(_vm.form.idcardImgBack)
      : null
  var m2 =
    !(_vm.currentStep === 1) &&
    !(_vm.qualificationType === "personal") &&
    !!_vm.form.legalPersonCard
      ? _vm.getFullPath(_vm.form.legalPersonCard)
      : null
  var m3 =
    !(_vm.currentStep === 1) &&
    !(_vm.qualificationType === "personal") &&
    !!_vm.form.legalPersonCardBack
      ? _vm.getFullPath(_vm.form.legalPersonCardBack)
      : null
  var m4 =
    !(_vm.currentStep === 1) &&
    !(_vm.qualificationType === "personal") &&
    !!_vm.form.businessImg
      ? _vm.getFullPath(_vm.form.businessImg)
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.currentStep = 1
    }
    _vm.e1 = function ($event) {
      _vm.currentStep = 2
    }
    _vm.e2 = function ($event) {
      _vm.showAreaPicker = true
    }
    _vm.e3 = function ($event) {
      _vm.showAreaPicker = false
    }
    _vm.e4 = function ($event) {
      _vm.currentStep = 1
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3,
        m4: m4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }